module.exports = __webpack_public_path__ + "static/img/member250107TW.e5c2b7b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/member250107TW.jpg
// module id = yvBn
// module chunks = 1